<template>
  <v-dialog v-model="dialog" persistent no-click-animation :width="st <= 1 ? 800 : 1000">
    <v-stepper v-if="dialog" v-model="st">
      <v-stepper-header>
        <v-stepper-step step="1" :complete="st > 1">{{ $t('welcome') }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" :complete="st > 2">{{ $t('pick') }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3" :complete="st > 3">{{ $t('location') }}</v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4" :complete="st > 4">{{ $t('deploy') }}</v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <app-deploy-welcome @next="st++" @cancel="cancel()">
            </app-deploy-welcome>
        </v-stepper-content>
        <v-stepper-content step="2">
          <app-deploy-pick v-if="st>=2" @next="st++" @prev="st--" @cancel="cancel()">
          </app-deploy-pick>
        </v-stepper-content>
        <v-stepper-content step="3">
          <app-deploy-location v-if="st>=3" @next="st++" @prev="st--" @cancel="cancel()">
          </app-deploy-location>
        </v-stepper-content>
        <v-stepper-content step="4">
          <app-deploy-install v-if="st>=4" @next="cancel()" @prev="st--" @cancel="cancel()">
          </app-deploy-install>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </v-dialog>
</template>

<script>
import DeployWelcomeComponent from '@/components/DeployWelcome.vue'
import DeployPickComponent from '@/components/DeployPick.vue'
import DeployLocationComponent from '@/components/DeployLocation.vue'
import DeployInstallComponent from '@/components/DeployInstall.vue'

export default {
  data () {
    return {
      dialog: false,
      st: 1,
      currentNamespace: false
    }
  },
  props: {
    open: Boolean
  },
  watch: {
    open (newVal) {
      if (newVal) {
        this.st = 1
      }
      this.dialog = newVal
    }
  },
  methods: {
    reset () {
      this.st = 1
    },
    cancel () {
      this.dialog = false
      this.$store.commit('resetWizard')
      this.$emit('close')
    }
  },
  components: {
    'app-deploy-welcome': DeployWelcomeComponent,
    'app-deploy-pick': DeployPickComponent,
    'app-deploy-location': DeployLocationComponent,
    'app-deploy-install': DeployInstallComponent
  }
}
</script>

<i18n>
{
  "en": {
    "welcome": "Goal",
    "pick": "Pick Deployment",
    "location": "Select Location",
    "deploy": "Deploy"
  }
}
</i18n>

<style lang="scss">
.v-stepper {
  border-radius: 0;
}

.v-stepper__header {
  margin-bottom: 5px;
}

.v-stepper__items {
  &, .v-stepper__wrapper {
    overflow: visible;
  }
}

.v-stepper__content {
  padding: 0;
}

@media (max-height: 730px) {
  .v-stepper__header {
    display: none;
  }
}
</style>
